import React from "react";

import { math, gk, history, science, english } from "../../assets";

const Categories = () => {
  return (
    <section id="subjects" className="flex flex-col sm:px-16 px-6 py-16 gap-10">
      {/* Heading */}
      <h2 className="text-secondary sm:text-[40px] text-[32px] font-bold">
        Our Entrance Categories
      </h2>
      {/* container for all the cards */}
      <div className="grid md:grid-cols-12 sm:grid-cols-8 grid-cols-4 gap-6 w-full">
        {/* card 1 of first row */}
        <div className="hover:scale-105 hover:ease-in transition duration-150 shadow-md border border-gray-200 col-span-4 flex flex-col gap-[18px] bg-transparent h-[352px] p-8 rounded-md">
          <div className="bg-white rounded-[50%] h-[100px] w-[100px] p-3">
            <img src={math} className="h-[76px] w-[76px]" alt="math" />
          </div>
          <h3 className="text-[20px] font-semibold leading-8 text-secondary">
            IOE
          </h3>
          <p className="leading-8 text-black">
            Sky was cloudless and of a deep dark blue spectacle before us was
            indeed
          </p>
        </div>
        {/* card 2 of first row */}
        <div className="hover:scale-105 hover:ease-in transition duration-150 shadow-md border border-gray-200 col-span-4 flex flex-col gap-[18px] bg-transparent  h-[352px] p-8 rounded-md">
          <div className="bg-white rounded-[50%] h-[100px] w-[100px] p-3">
            <img src={english} className="h-[76px] w-[76px]" alt="math" />
          </div>
          <h3 className="text-[20px] font-semibold leading-8 text-secondary">
            Loksewa
          </h3>
          <p className="leading-8 text-black">
            Sky was cloudless and of a deep dark blue spectacle before us was
            indeed
          </p>
        </div>

        {/* Card 3 of first row */}
        <div className="hover:scale-105 hover:ease-in transition duration-150 shadow-md border border-gray-200 col-span-4 flex flex-col gap-[18px] bg-transparent  h-[352px] p-8 rounded-md">
          <div className="bg-white rounded-[50%] h-[100px] w-[100px] p-3">
            <img src={science} className="h-[76px] w-[76px]" alt="math" />
          </div>
          <h3 className="text-[20px] font-semibold leading-8 text-secondary">
            MBBS
          </h3>
          <p className="leading-8 text-black">
            Sky was cloudless and of a deep dark blue spectacle before us was
            indeed
          </p>
        </div>
        {/* card 1 of second row */}
        <div className="hover:scale-105 hover:ease-in transition duration-150 shadow-md border border-gray-200 col-span-4 flex flex-col gap-[18px] bg-transparent  h-[352px] p-8 rounded-md">
          <div className="bg-white rounded-[50%] h-[100px] w-[100px] p-3">
            <img src={history} className="h-[76px] w-[76px]" alt="math" />
          </div>
          <h3 className="text-[20px] font-semibold leading-8 text-secondary">
            IELTS
          </h3>
          <p className="leading-8 text-black">
            Sky was cloudless and of a deep dark blue spectacle before us was
            indeed
          </p>
        </div>
        {/* card 2 of second row */}
        <div className="hover:scale-105 hover:ease-in transition duration-150 shadow-md border border-gray-200 col-span-4 flex flex-col gap-[18px] bg-transparent  h-[352px] p-8 rounded-md">
          <div className="bg-white rounded-[50%] h-[100px] w-[100px] p-3">
            <img src={gk} className="h-[76px] w-[76px]" alt="math" />
          </div>
          <h3 className="text-[20px] font-semibold leading-8 text-secondary">
            General Knowledge
          </h3>
          <p className="leading-8 text-black">
            Sky was cloudless and of a deep dark blue spectacle before us was
            indeed
          </p>
        </div>
        {/* Card 3 of second row */}
        <div className="hover:scale-105 hover:ease-in transition duration-150 shadow-md border border-gray-200 col-span-4 flex flex-col gap-[18px] bg-transparent  h-[352px] p-8 rounded-md">
          <div className="bg-white rounded-[50%] h-[100px] w-[100px] p-3">
            <img src={gk} className="h-[76px] w-[76px]" alt="math" />
          </div>
          <h3 className="text-[20px] font-semibold leading-8 text-secondary">
            Quantitative Ability
          </h3>
          <p className="leading-8 text-black">
            Sky was cloudless and of a deep dark blue spectacle before us was
            indeed
          </p>
        </div>
      </div>
      {/* <div className="flex justify-between flex-col gap-6 sm:px-8 px-0">

        <div className="flex sm:flex-row flex-col justify-items-start gap-6">

          <div className="flex flex-col gap-[18px] bg-transparent  h-[352px] p-8 rounded-md">
            <div className="bg-white rounded-[50%] h-[100px] w-[100px] p-3">
              <img src={math} className="h-[76px] w-[76px]" alt="math" />
            </div>
            <h3 className="text-[20px] font-semibold leading-8 text-secondary">
              Math
            </h3>
            <p className="leading-8 text-[#333333] opacity-50">
              Sky was cloudless and of a deep dark blue spectacle before us was
              indeed
            </p>

          <div className="flex flex-col bg-backgroundSecondary md:w-[370px] max-w-[370px] w-full h-[352px] sm:mt-[100px] p-8 rounded-md">
            <div className="bg-white rounded-[50%] h-[100px] w-[100px] p-3">
              <img src={english} className="h-[76px] w-[76px]" alt="math" />
            </div>
            <h3 className="text-[20px] font-semibold leading-8 text-secondary">
              English
            </h3>
            <p className="leading-8 text-[#333333] opacity-50">
              Sky was cloudless and of a deep dark blue spectacle before us was
              indeed
            </p>
          </div>
        </div>

        <div className="flex sm:flex-row flex-col justify-end gap-6">

          <div className="flex flex-col md:w-[270px] max-w-[370px] w-full h-[352px] sm:mt-[-100px] p-8 rounded-md">
            <div className="bg-white rounded-[50%] h-[100px] w-[100px] p-3">
              <img src={science} className="h-[76px] w-[76px]" alt="math" />
            </div>
            <h3 className="text-[20px] font-semibold leading-8 text-secondary">
              Science
            </h3>
            <p className="leading-8 text-[#333333] opacity-50">
              Sky was cloudless and of a deep dark blue spectacle before us was
              indeed
            </p>
          </div>

          <div className="flex flex-col bg-backgroundSecondary md:w-[270px] max-w-[370px]  w-full md:h-[320px] h-[360px] p-8 rounded-md">
            <div className="bg-white rounded-[50%] h-[100px] w-[100px] p-3">
              <img src={history} className="h-[76px] w-[76px]" alt="math" />
            </div>
            <h3 className="text-[20px] font-semibold leading-8 text-secondary">
              History
            </h3>
            <p className="leading-8 text-[#333333] opacity-50">
              Sky was cloudless and of a deep dark blue spectacle before us was
              indeed
            </p>
          </div>

          <div className="flex flex-col md:w-[370px] max-w-[370px] w-full h-[352px] p-8 rounded-md">
            <div className="bg-white rounded-[50%] h-[100px] w-[100px] p-3">
              <img src={gk} className="h-[76px] w-[76px]" alt="math" />
            </div>
            <h3 className="text-[20px] font-semibold leading-8 text-secondary">
              General Knowledge
            </h3>
            <p className="leading-8 text-[#333333] opacity-50">
              Sky was cloudless and of a deep dark blue spectacle before us was
              indeed
            </p>
          </div>
        </div>
      </div> */}
    </section>
  );
};

export default Categories;
